import gql from 'graphql-tag'

import { AddressFieldsFragment } from 'main/gql/address'

export const GatheringFieldsFragment = gql`
  fragment GatheringFields on Gathering {
    id
    slug
    type
    name
    description
    beginsAt
    endsAt
    address {
      ...AddressFields
    }
  }

  ${AddressFieldsFragment}
`
